import { getMessages } from 'app/store/constants';

export const TITLE_NOTIFICATIONS = getMessages().getText('common.notifications');
export const PUSH_NOTIFICATIONS = getMessages().getText('hint.push_notifications');
